import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

// Enum options extracted from the Ruby `level` enum for users_strategies_permissions.
// These match the enum values in the Ruby model:
export const levelOptions = [
  { value: "1", label: "Owner" },
  { value: "2", label: "Cockpit Viewer" },
  { value: "3", label: "Approver" },
  { value: "41", label: "Listed for Company" },
  { value: "42", label: "Listed for Portfolio" },
  { value: "43", label: "Listed for User" },
  { value: "44", label: "Listed Public" },
  { value: "45", label: "Listed Protected" },
];

export const filterStrategyPermissionSchema = z.object({
  // filter on the `level` enum
  level_equals: z.string().nullable().optional(),
});

export type FilterStrategyPermissionSchema = z.infer<
  typeof filterStrategyPermissionSchema
>;

export const fields: Field[] = [
  {
    name: "level_equals",
    label: "Level",
    type: "select",
    useTranslation: false,
    options: levelOptions,
  },
];

export const client = "legacy-quantilia";

export function FilterStrategyPermission() {
  return (
    <FilterTable
      client={client}
      schema={filterStrategyPermissionSchema}
      tableName="strategy_permissions"
      customBuildPath={() => `${client}/strategy_permissions`}
      fields={fields}
    />
  );
}
